import { render, staticRenderFns } from "./JdpTestSettings.vue?vue&type=template&id=bcc299f2&scoped=true&"
import script from "./JdpTestSettings.vue?vue&type=script&lang=ts&"
export * from "./JdpTestSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc299f2",
  null
  
)

export default component.exports